import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import * as resActions from "../../modules/resources";
import PropTypes from "prop-types";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import Loader from "Components/loader/Loader";
import { formatServerErrors } from "Utils/serverFormats";

import Stepper from "Components/stepper2/Stepper";
import Emails from "./add_form/Emails.jsx";
import Retention from "./add_form/Retention.jsx";
import Option from "./add_form/Option.jsx";
import Recap from "./add_form/Recap.jsx";
import Congratulations from "./add_form/Congratulations.jsx";

const propTypes = {};

const ContextTypes = {
  isLoggedUserTrial: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func
};

const formInitialState = {
  email_codes: {},
  domain_code: undefined,
  retention: 10,
  default_archive: true
};

class DomainNewScreen extends React.Component {
  constructor(props) {
    super(props);

    this.prevStep = this.prevStep.bind(this);
    this.goToStep = this.goToStep.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.setData = this.setData.bind(this);
    this.resetAndGoBack = this.resetAndGoBack.bind(this);
    this.getUserLimits = this.getUserLimits.bind(this);
    props.refreshAccount();
    if (!props.domain && props.match.params.domainCode) {
      props.getDomain(props.match.params.domainCode);
    }

    const isAddingDomain = !props.match.params.domainCode;

    this.state = {
      currentStep: 1,
      steps: isAddingDomain
        ? {
            1: {
              component: <Emails />
            },
            2: {
              component: <Retention />
            },
            3: {
              component: <Option />
            },
            4: {
              component: <Recap />
            },
            5: {
              component: <Congratulations />
            }
          }
        : {
            1: {
              component: <Emails />
            },
            4: {
              component: <Recap />
            },
            5: {
              component: <Congratulations />
            }
          },
      data: {},
      isAddingDomain: !props.match.params.domainCode,
      available: undefined,
      loadingLimits: true
    };
  }

  UNSAFE_componentWillMount() {
    this.getUserLimits();
  }

  getUserLimits(code = null) {
    const api = new QboxmailApi({ useCookie: true });

    api
      .getLimitsStatus(code)
      .then(r => {
        this.setState({ loadingLimits: false, available: r.resources[0].remaining_archive });
      })
      .catch(e => {
        console.log("error getting limit");
      });
  }

  componentDidMount() {
    const { domain } = this.props;
    const { isAddingDomain } = this.state;

    if (domain && !isAddingDomain) {
      this.props.setInitialValues({
        retention: domain.default_retention,
        domain_code: domain.code,
        default_archive: true
      });
    }
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.domain && nextProps.domain) {
      this.props.setInitialValues({
        retention: nextProps.domain.default_retention,
        domain_code: this.props.match.params.domainCode
      });
    }
  }

  setData(data) {
    this.setState({ data: Object.assign({}, this.state.data, data) });
  }

  goToStep(no) {
    // this.props.history.push(`${this.props.location.pathname}#${no}`)
    this.setState({ currentStep: no });
  }

  prevStep() {
    if (this.state.currentStep === 1) return;

    if (!this.state.isAddingDomain) {
      this.setState({ currentStep: 1 });
    } else {
      this.setState({ currentStep: this.state.currentStep - 1 });
    }
  }

  showStepNumber(no) {
    return this.state.steps[no];
  }

  returnToList() {
    const {
      match: {
        params: { domainCode }
      },
      location: { state }
    } = this.props;
    if (domainCode) {
      this.props.history.push(
        `/archive/domains/${domainCode}/email_accounts${(state && state.prevPagination) || ""}`
      );
    } else {
      this.props.history.push(`/archive${(state && state.prevPagination) || ""}`);
    }
  }

  submitForm() {
    this.props.setFormLoading();
    const codes = _.compact(
      _.map(this.props.formData.email_codes, (v, k) => {
        if (v) return k;
      })
    );
    const dataToSend = Object.assign({}, this.props.formData, { email_codes: codes });
    const api = new QboxmailApi({ useCookie: true });

    const methodToCall = this.props.match.params.domainCode
      ? "enableArchiveEmail"
      : "enableArchive";

    api[methodToCall](dataToSend.domain_code, dataToSend)
      .then(() => {
        this.goToStep(5);
      })
      .catch(response => {
        formatServerErrors(response).then(errors => {
          this.props.setFormErrors(errors);
          this.props.unsetFormLoading();
        });
      });
  }

  resetAndGoBack() {
    this.props.resetForm();
    this.returnToList();
  }

  render() {
    let toShow = this.showStepNumber(this.state.currentStep);
    const { formErrors, isDomainLoading } = this.props;
    const { isAddingDomain } = this.state;

    if (isDomainLoading && !isAddingDomain) {
      return <Loader />;
    }

    return (
      <div className="contentWrapper">
        {React.cloneElement(toShow.component, {
          ...this.props,
          goToStep: this.goToStep,
          submitForm: this.submitForm,
          onSuccess: () => this.onSuccess(),
          loggedUserType: this.context.getLoggedUserType(),
          isloggedUserInTrial: this.context.isLoggedUserTrial(),
          isLoggedUserAdmin: this.context.isLoggedUserAdmin(),
          isReseller: this.context.getLoggedUser().is_reseller,
          setData: this.setData,
          totalEmails: this.state.data.totalEmails,
          isAddingDomain: this.state.isAddingDomain,
          resetAndGoBack: this.resetAndGoBack,
          getUserLimits: this.getUserLimits,
          stepper: (
            <Stepper
              steps={isAddingDomain ? 4 : 2}
              active={this.state.currentStep}
              goBack={this.prevStep}
            />
          ),
          available: this.state.available,
          loadingLimits: this.state.loadingLimits
        })}
      </div>
    );
  }
}

//DomainNewScreen.propTypes = propTypes;
DomainNewScreen.contextTypes = ContextTypes;

const mapStateToProps = state => ({
  domain: resActions.getData("domain.data", state)[0],
  isDomainLoading: resActions.isResourceLoading("domain", state)
});

const mapDispatchToProps = dispatch => ({
  getDomain: code => dispatch(resActions.callApi("getDomain", "domain", code)),
  refreshAccount: () => dispatch(resActions.callApi("refreshAccount", "account")),
  refreshDomains: queryParams =>
    dispatch(resActions.callApi("refreshDomains", "domains", queryParams))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFormState(DomainNewScreen, formInitialState));
